import { SectionBody } from 'modules/emergencies/components/ticketForm/components/SectionBody';
import { SectionContainer } from 'modules/emergencies/components/ticketForm/components/SectionContainer';
import { SectionLine } from 'modules/emergencies/components/ticketForm/components/SectionLine';
import SectionSubTitle from 'modules/emergencies/components/ticketForm/components/SectionSubTitle';
import SectionTitle from 'modules/emergencies/components/ticketForm/components/SectionTitle';
import Separator from 'modules/emergencies/components/ui/layout/Separator';
import React from 'react';
import styled from 'styled-components';
import getCarriersUsersByCarrier from '../../api/getCarriersUsersByCarrier';
import useSWR from 'swr';
import ToolBarButton from 'modules/emergencies/components/ui/toolbar/toolBarButton';
import { useHistory } from 'react-router-dom';

const CustomSubtitle = styled(SectionSubTitle)`
  color: var(--grey500);
  margin: 0 auto;
`;

const CustomSubtitleUser = styled(CustomSubtitle)`
  margin-left: 0;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  width: 100%;
`;

const CustomSectionSubTitle = styled(SectionSubTitle)`
  justify-content: space-between;
  align-items: center;
  display: flex;
  width: 100%;
  ${ToolBarButton} {
    font-size: 14px;
  }
`;

const carriersUsersByCarrierFether = async (...args) => {
  const key = args[0];
  const carrierId = key.replace('carriersUsersByCarrierId-', '');
  return getCarriersUsersByCarrier(carrierId);
};

const useCarriersUsersList = ({ carrierId }) => {
  const requestKey = `carriersUsersByCarrierId-${carrierId}`;
  const fetcher = carriersUsersByCarrierFether;
  const { data: carriersUsersByCarrier, error: carriersUsersByCarrierError } = useSWR(
    requestKey,
    fetcher
  );

  const isLoadingCarriersUsersByCarrier = typeof carriersUsersByCarrier === 'undefined';

  return {
    isLoadingCarriersUsersByCarrier,
    carriersUsersByCarrier,
    carriersUsersByCarrierError,
  };
};

const CarrierUserListForNewUsers = () => {
  return (
    <SectionContainer>
      <SectionTitle>Users</SectionTitle>
      <SectionBody>
        <Separator />
        <SectionLine>
          <CustomSubtitle>
            It is necessary to create the carrier first to be able to add users
          </CustomSubtitle>
        </SectionLine>
        <Separator />
      </SectionBody>
    </SectionContainer>
  );
};

const CarrierUserListForExistingUsers = ({ carrierId }) => {
  const { isLoadingCarriersUsersByCarrier, carriersUsersByCarrier, carriersUsersByCarrierError } =
    useCarriersUsersList({ carrierId });
  const results = carriersUsersByCarrier?.results || [];
  const history = useHistory();

  const onUserClick = (carrierUserId) => {
    const newRoute = `/carrier/${carrierId}/carrier_user/${carrierUserId}/edit`;
    history.push(`${newRoute}`);
  };

  return (
    <SectionContainer>
      <SectionTitle>Users</SectionTitle>
      <SectionBody>
        <Separator />
        {isLoadingCarriersUsersByCarrier && (
          <SectionLine>
            <CustomSubtitle>Loading</CustomSubtitle>
          </SectionLine>
        )}
        {!isLoadingCarriersUsersByCarrier && !carriersUsersByCarrierError && results.length === 0 && (
          <SectionLine>
            <CustomSubtitle>This carrier has no users created yet </CustomSubtitle>
          </SectionLine>
        )}
        {!isLoadingCarriersUsersByCarrier && !carriersUsersByCarrierError && results.length > 0 && (
          <>
            {results.map((user, index) => (
              <React.Fragment key={user.id}>
                {index > 0 && (
                  <SectionLine>
                    <Separator />
                  </SectionLine>
                )}

                <SectionLine
                  onClick={() => {
                    onUserClick(user.id);
                  }}
                >
                  <CustomSubtitleUser>
                    <span style={{ display: 'inline-block', width: '40%' }}>{user.first_name}</span>
                    {user.email}
                  </CustomSubtitleUser>
                </SectionLine>
              </React.Fragment>
            ))}
          </>
        )}

        <Separator />
      </SectionBody>
      <CustomSectionSubTitle>
        <ToolBarButton
          onClick={() => {
            history.push(`/carrier/${carrierId}/carrier_user/new`);
          }}
        >
          Add user
        </ToolBarButton>
      </CustomSectionSubTitle>
    </SectionContainer>
  );
};

const CarrierUsersList = ({ carrierId }) => {
  if (carrierId === null) {
    return <CarrierUserListForNewUsers />;
  }
  return <CarrierUserListForExistingUsers carrierId={carrierId} />;
};

export default CarrierUsersList;
